export class CodedResponseModel {
	public success: boolean = false;
	public data: any = null;
	public message: string = '';


	public map(_data: any){
		this.success = _data.success;
		this.data = _data.data;
		this.message = _data.message;
	}
	public decodeData(){
		return this.data;
	}

	public static create(data:any){
		let r = new this;
		r.map(data);
		return r;
	}
	public static decode(data:any){
		return this.create(data).decodeData();
	}
}
